import Vue from 'vue'
import { DEFAULT_CURRENCY } from '@/utils/constants'
Vue.filter('extractInitialsByName', v => {
  const camelsRegexp = /[A-ZÑ]/
  const splitByCamel = v.split('').filter((e, k, arr) => camelsRegexp.test(e) && (k === 0 || !camelsRegexp.test(arr[k - 1])))
  if (splitByCamel.length >= 2) {
    return splitByCamel.join('').slice(0, 2).toUpperCase()
  }
  let words = v.split(' ')
  words = words.map(w => w.split('').filter(e => /[A-Za-z0-9ñÑ]/.test(e)))
  if (words.length === 1 && words[0].length < 2) return '  '
  const initials = words.length > 1 && words[1].length > 0 ? words[0][0] + words[1][0] : words[0][0] + words[0][1]
  return initials ? initials.toUpperCase() : ''
})

Vue.filter('formatTheDate', (date, dateFormat, noUTC) => {
  let format = 'MM/DD/YYYY'

  if (dateFormat === 'short') {
    format = 'DD/MM/YY'
  }

  if (dateFormat === 'short_date_year_long') {
    format = 'DD/MM/YYYY'
  }
  if (dateFormat === 'short_date_year_long_time') {
    format = 'DD/MM/YY - HH:mm'
  }
  if (dateFormat === 'short_date_year_long_time_simple') {
    format = 'DD/MM/YY HH:mm'
  }
  const moment = Vue.prototype.$moment

  const momentDate = noUTC ? moment(date) : moment.utc(date)

  return momentDate.format(format)
})

Vue.filter('stringifyJson', v => {
  return JSON.stringify(v, undefined, 1)
})

export const currency = function (value, currencyValue) {
  if (currencyValue === '' || !currencyValue) {
    currencyValue = DEFAULT_CURRENCY
  }
  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: currencyValue
  })
  return formatter.format(value)
}

export const getCurrencySymbol = function (currencyValue) {
  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: currencyValue,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
  return formatter.format(0).replace(/\d/g, '').trim()
}
